<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent && localService.languageContent.table && source">
  <div class="banner center" style="max-width:1000px;">
    <div class="row row_header freeze_height">
      <div class="col-2">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-4">
        {{localService.languageContent.table.title}}
      </div>
      <div class="col-6">
        {{localService.languageContent.table.route}}
        <div class="icon_action_header">
          <i class="material-icons" (click)="openMenu('')" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of source.items">
        <div class="col-2">
          <i class="material-icons button icon_adjust" title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ? "toggle_on" : "toggle_off"}}</i>
          <a class="button" *ngIf="item.v6 != '0'" [routerLink]="['/pagekeys' + localService.basicParamsString,2,item.v6]"><i class="material-icons button icon_adjust">key</i></a>
          <span class="en" style="float:right;">{{item.v2}}</span>
        </div>
        <div class="col-4">
          <span class="button" (click)="openMenu(item.key)">{{item.v5}}</span>
          <span class="en" *ngIf="item.v6 != '0'">&nbsp;({{item.v6}})&nbsp;</span>
        </div>
        <div class="col-6">
          <span class="en">{{item.v3}}</span>
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
